import { render, staticRenderFns } from "./checkBoxData.vue?vue&type=template&id=2bfa8cc3"
import script from "./checkBoxData.vue?vue&type=script&lang=js"
export * from "./checkBoxData.vue?vue&type=script&lang=js"
import style0 from "./checkBoxData.vue?vue&type=style&index=0&id=2bfa8cc3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports